import React from 'react';
import { Form } from 'react-bootstrap';
import '../styles/tableAdmin.css'; // Import your custom styles

const ItemsPerPageSelector = ({ itemsPerPage, onItemsPerPageChange }) => {
  const handleChange = (event) => {
    onItemsPerPageChange(parseInt(event.target.value, 10));
  };

  return (
    <div className='d-flex align-items-center justify-content-center gap-2'>
      <Form.Label htmlFor="itemsPerPageSelect" className='my-0'>Show</Form.Label>
      <Form.Select
        id="itemsPerPageSelect"
        size='sm'
        value={itemsPerPage}
        onChange={handleChange}
        className='custom-select-width'
      >
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </Form.Select>
      <Form.Label htmlFor="itemsPerPageSelect" className='my-0'>entries</Form.Label>
    </div>
  );
};

export default ItemsPerPageSelector;
